/**
 * Function created to replace isServer from `cms-blocks` package due to some errors on latest versions of nextJS and cypress
 * @returns boolean
 */
var isServer = function () { return typeof window === 'undefined'; };

export { isServer };
//# sourceMappingURL=isServer.esm.js.map
